import React, { useEffect,useContext } from "react";
import { Redirect } from "react-router-dom";
import { AppDivisionContext } from "../../contexts/AppDivisionContext";
import { InspectionReportButton } from "./Button";
import { env } from "../../config";

import "./_InspectionReportDownloadPage.scss";

export default function InspectionReportDownloadPage({ location }: any) {
  const search = new URLSearchParams(location.search);
  const reportId = search.get("reportId");
  const reportTitle = search.get("reportTitle");
  const tokenJSON = window.localStorage.getItem("token");
  const token = JSON.parse(tokenJSON || "") as string;
  const downloadUrl = `${env.REACT_APP_API_BASE_URL}/api/download/${reportId}.pdf?token=${token}`;
  const filename = `${reportTitle}.pdf`;
  const appDivisionContext = useContext(AppDivisionContext);

  if (!reportId || !reportTitle) {
    return <Redirect to="/download-not-found" />;
  }

  console.log(reportId, reportTitle);

  async function downloadFile() {
    const response = await fetch(downloadUrl);
    const data = await response.blob();
    var a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.setAttribute("download", filename);
    a.click();
  }

  useEffect(() => {
    setTimeout(async () => {
      await downloadFile();
    }, 2000);
  }, []);

  return (
    <div className="report-page">
      <img
        className="report-page__logo"
        src="/static/media/SW-Logo-White.svg"
      />

      <div className="report-page__synopsis">
        <h2 className="report-page__title">Download Report</h2>
        <h4>{reportTitle}</h4>
      </div>

      <p className="report-page__manual-download">
        Your download will start automatically.{" "}
        <a onClick={downloadFile}>Click Here</a> to download the file manually
      </p>

      <InspectionReportButton text="My Dashboard" to={appDivisionContext.getPath("/dashboard")} />
    </div>
  );
}
